import axios from 'axios'
import store from './../store';

export default class UserService {

    async getNumberOfUsers(token) {
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/users/number',
            headers: {
                authorization: token
            }
        });
        return res.data[0].num;
    }

    async getUser(id,token) {
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/users/'+id,
            headers: {
                authorization: token
            }
        });

        return res.data;
    }

    async getUserToken(email) {
        const res = await axios({
            method: 'post',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/users/loginas',
            headers: {
                authorization: store.state.currentUser.token
            }, 
            data: {
                email: email
            }
        });
        return res.data;
    }

    async getUserSelf( token) {
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/users/me',
            headers: {
                authorization: token
            }
        });
        return res.data;
    }

    async updateUser(user_data) {
        try {
            const result = await axios({
                method: 'put',
                headers: {
                    authorization: store.state.currentUser.token
                },
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/users/me',
                data: user_data
            })
            return result

        } catch (error) {
            if (error.response) {
                return error
            }
            return 0;
        }
    }

    async updateUserBank(bank_data) {
        try {
            const result = await axios({
                method: 'put',
                headers: {
                    authorization: store.state.currentUser.token
                },
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/users/me/bank',
                data: bank_data
            })
            return result
        } catch (error) {
            if (error.response) {
                return error
            }
            return 0;
        }

    }

    async updateUserPersonalData(user_data) {
        try {
            const result = await axios({
                method: 'put',
                headers: {
                    authorization: store.state.currentUser.token
                },
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/users/',
                data: user_data
            })
            return result

        } catch (error) {
            if (error.response) {
                return error
            }
            return 0;
        }
    }

    async updateCompany(company_data) {
        try {
            const result = await axios({
                method: 'put',
                headers: {
                    authorization: store.state.currentUser.token
                },
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/users/me/company',
                data: company_data
            })
            return result

        } catch (error) {
            if (error.response) {
                return error
            }
            return 0;
        }
    }

    async getRank(id, token) {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/users/rank/' + id,
            headers: {
                authorization: token
            }
        });



        return res.data.rank;
    }
    async getRankSelf(token) {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/users/rank/me',
            headers: {
                authorization: token
            }
        });



        return res.data.rank;
    }

    async setUserRank(user_data) {
        try {
            const result = await axios({
                method: 'put',
                headers: {
                    authorization: store.state.currentUser.token
                },
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/users/' + user_data.id + '/rank',
                data: {
                    rank_id: user_data.rank.id
                }
            })
            return result

        } catch (error) {
            if (error.response) {
                return error
            }
            return 0;
        }
    }

    async setUserRole(user_data) {
        try {
            const result = await axios({
                method: 'put',
                headers: {
                    authorization: store.state.currentUser.token
                },
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/users/' + user_data.id + '/role',
                data: {
                    role: user_data.role
                }
            })
            return result

        } catch (error) {
            if (error.response) {
                return error
            }
            return 0;
        }
    }

    async getUsers() {
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/users/',
            headers: {
                authorization: store.state.currentUser.token
            }
        });

        const data = res.data;
        data.map(el => {
            const name = el.name;
            const surname = el.surname;
            el.name = `${name} ${surname}`;
        });
        
        return res.data;
    }

    async getContacts() {
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/users/contacts/me',
            headers: {
                authorization: store.state.currentUser.token,
                id:store.state.currentUser.id
                
            }
        });

        const data = res.data;
        data.map(el => {
            const name = el.name;
            const surname = el.surname;
            el.name = `${name} ${surname}`;
        });

        return res.data;
    }

    async inviteFriends(invite) {
        try {
            const res = await axios({
                method: 'post',
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/users/invite',
                headers: {
                    authorization: store.state.currentUser.token
                },
                data: {
                    email: invite.emails,
                    msg: invite.msg,
                    link: invite.link,
                }
            });
            return res.data;
        } catch (error) {
            if (error.response) {
                return error
            }
            return 0;
        }

    }

    async getDataKeySelf() {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/users/datakey/me',
            headers: {
                authorization: store.state.currentUser.token
            }
        });



        return res.data;
    }
}




     



